<p class="action-buttons" fxLayout="row" fxLayoutAlign="end">
  <button mat-raised-button color="primary" (click)="addCategory()" aria-label="Add New Category">
      <mat-icon>add</mat-icon>
      <span>Add New Category</span>
  </button>
</p>
<mat-card class="mat-elevation-z3">
  <div class="table-wrapper">
      <table mat-table [dataSource]="dataSource" #table>
          <!-- Name Column -->
          <ng-container matColumnDef="categoryName">
              <th mat-header-cell *matHeaderCellDef>Name</th>
              <td mat-cell *matCellDef="let category">{{ category.categoryName }}</td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef style="width: 120px"></th>
              <td mat-cell *matCellDef="let category" style="text-align: center;">
                  <button mat-flat-button color="primary" (click)="editCategory(category)">Edit</button>
                  <button mat-flat-button color="warn" (click)="deleteCategory(category)">Delete</button>
              </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns" [class.evenRow]="even"></tr>
      </table>
  </div>
</mat-card>
